import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Icon from '../../../icon/index';
import {isUpgradeToBusinessPopup as setIsUpgradeToBusinessPopup, videoPopup} from '../../../../../actions/popupActions';
import Button from '../../../button';
import Popup from '../../index';
import {API_ROOT} from '../../../../utils';
import {useTranslation} from 'react-i18next';
import {postEngagement} from '../../../../../actions/engagementActions';
import './index.css';

function UpgradeToBusinessPopup () {

    const [video, setVideo] = useState({
		id: 'Dr1wBIrhLzo',
		preview: API_ROOT + '/img/7-reasons-to-upgrade-en.jpg'
	});

    const { t } = useTranslation();
    const language = useSelector(state => state.languageReducer.language);
    const isUpgradeToBusinessPopup = useSelector(state => state.popupReducer.isUpgradeToBusinessPopup);

	const dispatch = useDispatch();

    const handlePlay = () => {

	    dispatch(postEngagement(58, new Intl.DateTimeFormat('fr-FR', {
		    day: '2-digit',
		    month: '2-digit',
		    year: '2-digit',
		    hour: '2-digit',
		    minute: '2-digit',
		    second: '2-digit',
	    }).format()));

	    if(isUpgradeToBusinessPopup){
		    dispatch(setIsUpgradeToBusinessPopup(false));
	    }

		setTimeout(() => {
			dispatch(videoPopup(video.id));
		}, 250)
	};

    const handleUpgrade = () => {
	    dispatch(postEngagement(59, new Intl.DateTimeFormat('fr-FR', {
		    day: '2-digit',
		    month: '2-digit',
		    year: '2-digit',
		    hour: '2-digit',
		    minute: '2-digit',
		    second: '2-digit',
	    }).format()));

	    // Webful In-App Analytics
	    window.webful?.track('upgrade_clicked');
    };

	useEffect(() => {
		switch (language) {
			case 'fr' :
				setVideo({
					id: '7yg9nr41gTw',
					preview: API_ROOT + '/img/7-reasons-to-upgrade-fr.jpg'
				});
				break;
			case 'es' :
				setVideo({
					id: 'iGwo6QCf6bc',
					preview: API_ROOT + '/img/7-reasons-to-upgrade-es.jpg'
				});
				break;
			default :
				setVideo({
					id: 'Dr1wBIrhLzo',
					preview: API_ROOT + '/img/7-reasons-to-upgrade-en.jpg'
				});
				break;
		}
	}, [language]);

	const close = () => {
		dispatch(setIsUpgradeToBusinessPopup(false))
	};

    return (
        <Popup className="upgrade-to-business-popup" onClose={close}>
            <h2>{t('upgradeToBusinessTitle')}</h2>
            <p>{t('upgradeToBusinessContent')}</p>
            <div>
                <button className="video-button" onClick={handlePlay}>
                    <Icon name="play-circle" />
                    <img data-video={video.id} className="d-block" src={video.preview} width="300" alt=""/>
                </button>
            </div>
            <div>
                <Button onClick={ handleUpgrade } href={`/payment/upgrade`} className="btn-primary">{t('upgradeToBusinessBtn')}</Button>
            </div>
	        <div>
		        <Button className="mt-3 btn-link" onClick={close}>{t('upgradeToBusinessSkip')}</Button>
	        </div>
        </Popup>
    )
}

export default UpgradeToBusinessPopup;
